import React from 'react';

const SpinningSankalvaXLogo = ({ size = 'w-4 h-4', className = '', showBackground = false }) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 668 773"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${size} animate-spin ${className}`}
      preserveAspectRatio="xMidYMid meet"
    >
      {/* SankalvaX Logo Path */}
      <g transform="translate(0,773) scale(0.1,-0.1)">
        <path
          d="M3230 7673 c-52 -30 -151 -88 -220 -128 -69 -39 -200 -115 -291 -168 -92 -53 -236 -136 -320 -185 -85 -48 -230 -133 -324 -187 -93 -54 -242 -139 -330 -190 -88 -50 -218 -126 -290 -167 -71 -41 -173 -100 -225 -130 -52 -30 -171 -99 -265 -153 -335 -194 -513 -297 -732 -422 l-223 -128 3 -1934 2 -1933 825 -477 c2427 -1404 2513 -1453 2534 -1443 12 6 238 136 502 289 265 153 1004 579 1642 948 l1161 670 1 1946 0 1945 -1157 669 c-637 367 -1379 796 -1649 951 -344 199 -500 284 -520 283 -16 0 -71 -25 -124 -56z m945 -2398 l804 -460 -2 -934 -2 -933 -810 -464 -809 -463 -44 24 c-23 13 -250 142 -503 287 l-459 262 0 931 0 930 492 280 c270 154 499 281 509 283 9 2 241 -125 515 -281 l499 -284 3 -571 2 -570 -496 -282 c-273 -155 -503 -284 -513 -286 -9 -3 -101 44 -206 104 l-190 109 -2 559 c-2 308 1 564 5 571 6 10 346 207 379 220 11 4 239 -117 306 -163 16 -10 -5 -25 -177 -124 l-196 -112 2 -384 3 -385 36 -21 36 -20 346 198 347 198 0 387 0 388 -333 190 c-183 104 -340 193 -349 196 -12 5 -129 -57 -355 -186 -186 -106 -341 -197 -345 -203 -4 -6 -8 -342 -8 -747 l0 -737 346 -197 c313 -179 348 -196 370 -186 33 15 1265 720 1282 733 9 8 12 171 12 753 l0 742 -656 374 c-361 206 -658 374 -661 373 -2 -1 -297 -167 -653 -370 l-649 -369 -1 -927 c0 -736 -3 -928 -12 -928 -7 0 -78 38 -158 84 l-145 84 0 933 0 933 805 462 c443 255 811 462 817 461 7 -1 375 -209 818 -462z"
          fill="currentColor"
          stroke="none"
        />
      </g>
    </svg>
  );
};

export default SpinningSankalvaXLogo;